import gql from 'graphql-tag'
import { listMedias } from './fragments'

export default gql`
query listMedia($filter: MediaFilterArgs $params: ListQueryArgs) {
	cashAssist {
		listMedia(filter: $filter, params: $params) {
			...listMedias
		}
	}
}
${listMedias}`
